import React, { Component } from "react";
import style from "./ViewPatient.module.css";
import { connect } from "react-redux";
import moment from "moment";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
} from "reactstrap";
import { 
    fetchRelatedParty,
    fetchMedSchemes,
    fetchMedSchemesPlan,
    fetchMedSchemesPlanOptions,
    fetchMedSchemesPlanSubOptions, } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { Link } from "react-router-dom";
import Api from "../../utils/Api";
import { dateFormatter } from "../../utils/CommonUtil";
import MSVDetailsSection from "../../containers/MSVDetailsSections";

const Tabs = [{
    tabId: 1,
    tabName: "General Details",
    enable: 1
},
{
    tabId: 2,
    tabName: "MSV Details",
    enable: 1
}];


export class ViewPatient extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: "1",
            isScreenLoaded: false
        };
    }

    componentDidMount = async() => {
        document.title = 'Patient Details - TechToMedix';
        if (this.props.match.params.id) {
            await this.props.fetchRelatedParty(this.props.match.params.id);
            this.props.fetchMedSchemes("");
            await this.getAllSchemesData();
        }
        setTimeout(() => {
            this.setState({
                isScreenLoaded: true,
            });
        }, 2000);
    }

    
    componentDidUpdate = async (prevProps, prevState) => {
        //document.title = 'TechToMed - Edit Contact';
        if (prevProps.match.params.id !== this.props.match.params.id) {
            if (this.props.match.params.id) {
                await this.props.fetchRelatedParty(this.props.match.params.id);
                await this.getAllSchemesData();
            }
        }

    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    getTitle = (dataId) => {
       const dropdownListData = this.props.dropdownListData && this.props.dropdownListData.dropdownList;
       let titleObj = {};
       if(dataId){
        titleObj = dropdownListData && dropdownListData.prefix && dropdownListData.prefix.find((item)=>(
             item.prefix_id === Number(dataId)
        ))

       }

        return titleObj && titleObj.prefix_name? titleObj.prefix_name : "";
    }

    getRelation = (dataId) => {
        const dropdownListData = this.props.dropdownListData && this.props.dropdownListData.dropdownList;
        let relationObj = {};
        if(dataId){
            relationObj = dropdownListData && dropdownListData.lk_patient_relation && 
            dropdownListData.lk_patient_relation.find((item)=>(
              item.code === dataId
         ))
 
        }
 
         return relationObj && relationObj.patient_relation? relationObj.patient_relation : "";
    }

    getAllSchemesData = async() => {
        const relatedPartyDetails =  this.props.relatedPartyData && this.props.relatedPartyData.relatedPartyData &&
            this.props.relatedPartyData.relatedPartyData.relatedPartyDetails;
        if (relatedPartyDetails && relatedPartyDetails.scheme_code) {
            this.props.fetchMedSchemesPlan(relatedPartyDetails.scheme_code);
        }

        if (relatedPartyDetails && relatedPartyDetails.scheme_plan_code) {
            this.props.fetchMedSchemesPlanOptions(relatedPartyDetails.scheme_plan_code);
        }

        if (relatedPartyDetails && relatedPartyDetails.scheme_plan_option_code) {
            this.props.fetchMedSchemesPlanSubOptions(relatedPartyDetails.scheme_plan_option_code);
        }
    }


    getSchemeName = (code) => {
        const schemesDropDownListData = this.props.schemesData && this.props.schemesData.schemes;
        let schemeObj = {};
        if(code){
            schemeObj = schemesDropDownListData && schemesDropDownListData.find((item=>(
                     item.code === code
             )))
        }

        return schemeObj && schemeObj.name ? (schemeObj.name + " (" + schemeObj.code + ")") : "Not Available";
    }
    getSchemePlanName = (code) => {
        const schemesPlanDropDownListData = this.props.schemesPlanData && this.props.schemesPlanData.schemesPlan;

        let schemeObj = {};
        if(code){
            schemeObj = schemesPlanDropDownListData && schemesPlanDropDownListData.find((item=>(
                        item.code === code
                )))
       }

        return schemeObj && schemeObj.name ? (schemeObj.name + " (" + schemeObj.code + ")") : "Not Available";
    }
    getSchemePlanOptionName = (code) => {
        const schemesPlanOptionsDropDownListData = this.props.schemesPlanOptionsData && this.props.schemesPlanOptionsData.schemesPlanOptions;

        let schemeObj = {};
        if(code){
            schemeObj = schemesPlanOptionsDropDownListData && schemesPlanOptionsDropDownListData.find((item=>(
                        item.code === code
                )))
       }

        return schemeObj && schemeObj.name ? (schemeObj.name + " (" + schemeObj.code + ")") : "Not Available";
    }
    getSchemePlanSubOptionName = (code) => {
        const schemesPlanSubOptionsDropDownListData = this.props.schemesPlanSubOptionsData && this.props.schemesPlanSubOptionsData.schemesPlanSubOptions;

        let schemeObj = {};
        if(code){
            schemeObj = schemesPlanSubOptionsDropDownListData && schemesPlanSubOptionsDropDownListData.find((item=>(
                        item.code === code
                )))
       }

        return schemeObj && schemeObj.name ? (schemeObj.name + " (" + schemeObj.code + ")") : "Not Available";
    }
    // api call for download attachment
  downloadAttachment = async (attachment_id, file_name) => {
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    try {
      const response = await Api.get("attachment/" + attachment_id, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Attachment downloaded successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file_name);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download file", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in download file",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  checkData = (data) => {
    if (!data) {
        return "Not Available";
    }
    return data;
}

  // Download patient file
  onDownloadSubmitFile = async (relatedPartyData) => {
    this.setState({
      isCaseFileDownloading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      patient_id: relatedPartyData.related_party_id,
    };

    try {
      const response = await Api.post(
        "appointment/patientfile/download",
        payload,
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Case file download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(relatedPartyData && relatedPartyData.file_number){
          link.setAttribute("download", `${relatedPartyData.file_number}.pdf`);
        }else{
          link.setAttribute("download", `${relatedPartyData.name} ${relatedPartyData.surname}.pdf`);
        }
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  getMSVDetails = () => {

    const msvHistory =
    this.props.relatedPartyData &&
    this.props.relatedPartyData.relatedPartyData &&
    this.props.relatedPartyData.relatedPartyData.msvHistory;
    return (
        <div className="row">   
            {msvHistory && msvHistory.map((msvObj, index)=>(
            <div key={index} className="col-md-12 mt-4">
                <MSVDetailsSection 
                data={msvObj}
                saveMSVData={this.saveMSVData}
                claimProcess={false} />
                </div>
                ))}

                {!msvHistory || (msvHistory && msvHistory.length === 0) && ( 
                    <p className="textCenter">No MSV details found!</p>
                )}
           </div>
    );
  }


    getGeneralDetails =()=>{

        const relatedPartyDetails =
            this.props.relatedPartyData &&
            this.props.relatedPartyData.relatedPartyData &&
            this.props.relatedPartyData.relatedPartyData.relatedPartyDetails;


        // attachment
        const attachmentData =
            this.props.relatedPartyData &&
            this.props.relatedPartyData.relatedPartyData.attachment;

        return (
            <div className={style.productviewDetailsWrapper}>
                <div className="row">
                    
                    <div className="col-md-12">
                       {relatedPartyDetails && relatedPartyDetails.name &&( 
                       <h5 className="patientkey">
                          {this.getTitle(relatedPartyDetails.title)}. {relatedPartyDetails.name} {relatedPartyDetails.surname?relatedPartyDetails.surname: ""}
                       </h5>
                       )}
                       <hr />
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Contact Type:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                {relatedPartyDetails &&
                                this.checkData(relatedPartyDetails.related_party_type
                                    .charAt(0)
                                    .toUpperCase() +
                                relatedPartyDetails.related_party_type.slice(1))}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Patient Type:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                {relatedPartyDetails &&
                                relatedPartyDetails.isMedicalAidPatient === 1? "Medical Aid Patient" : "Private Patient"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row ">
                    <div className="col-md-12">
                        <h5 className={style.viewHeading}>Patients Details</h5>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Title of the Contact:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.role_name)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Title:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getTitle(relatedPartyDetails.title))}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">First Name:</p>
                            </div>
                            <div className="col-md-6">
                                <p>{relatedPartyDetails && this.checkData(relatedPartyDetails.name)}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Last Name:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.surname)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Full Name:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.fullname)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Initials:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.initials)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Date Of Birth:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {" "}
                                    {relatedPartyDetails &&
                                        this.checkData(dateFormatter(relatedPartyDetails.dob))}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Gender:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        this.checkData(relatedPartyDetails.gender)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">ID/Passport Number:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        this.checkData(relatedPartyDetails.passport_number)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Physical Address:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        this.checkData(relatedPartyDetails.physical_address)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Postal Address:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        this.checkData(relatedPartyDetails.postal_address)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Cell Phone Number:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        this.checkData(relatedPartyDetails.contact_number)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Email Address:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.email)}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Height:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && relatedPartyDetails.height?relatedPartyDetails.height+" cms":"Not Available"}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Weight:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && relatedPartyDetails.weight?relatedPartyDetails.weight+" gms":"Not Available"}
                                </p>
                            </div>
                        </div>
                    </div> */}
                    
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Communication:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        relatedPartyDetails.communication_mode}
                                </p>
                            </div>
                        </div>
                    </div>
                     <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Height:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        relatedPartyDetails.height}
                                </p>
                            </div>
                        </div>
                    </div>
                     <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Weight:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails &&
                                        relatedPartyDetails.weight}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

{(relatedPartyDetails && relatedPartyDetails.isMedicalAidPatient !== 0 && 
relatedPartyDetails.isMedicalAidPatient === 1) &&(
    <React.Fragment>
                <hr />
                <div className="row ">
                    <div className="col-md-12">
                        <h5 className={style.viewHeading}>Main Member Details</h5>
                    </div>
                    
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Member Full Name:</p>
                            </div>
                            <div className="col-md-6">
                                <p>{relatedPartyDetails && this.checkData(relatedPartyDetails.member_fullname)}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Member Surname:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.member_surname)}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Member Initials:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.member_initials)}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Membership Number:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.membership_number)}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Medical Aid Scheme:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getSchemeName(relatedPartyDetails.scheme_code))}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Medical Aid Scheme Plan:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getSchemePlanName(relatedPartyDetails.scheme_plan_code))}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Medical Aid Plan Option:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getSchemePlanOptionName(relatedPartyDetails.scheme_plan_option_code))}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Medical Aid Plan Suboption:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getSchemePlanSubOptionName(relatedPartyDetails.scheme_plansuboption_code))}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Member Passport Number:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.membership_passport_number)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Relationship with Main Member:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(this.getRelation(relatedPartyDetails.patient_relationship_code))}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <p className="patientkey">Dependant Code:</p>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    {relatedPartyDetails && this.checkData(relatedPartyDetails.dependant_code)}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                </React.Fragment>)}
                {attachmentData && attachmentData.length > 0 && (
                   <React.Fragment>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <h6 className={style.viewHeading}>Other:</h6>
                    </div>
                    {attachmentData && attachmentData.length > 0 && (
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <p className="patientkey">Upload Documents:</p>
                                </div>
                                <div className="col-md-12 uploaded-documents">
                                    {attachmentData &&
                                        attachmentData.map((element, index) => (
                                                    <div key={index} class="row mb-2">
                                                        <div class="col-md-4">
                                                        <Link key={index}
                                                            className={style.downloadLink}
                                                            onClick={() => {
                                                                this.downloadAttachment(
                                                                    element.attachment_id,
                                                                    element.attachment_file_name
                                                                );
                                                            }}
                                                        >
                                                                <span><i class="fa fa-paperclip mr-1"></i>
                                                                {element.attachment_file_name}
                                                                </span>
                                                                </Link>
                                                            </div>
                                                        <div class="col-md-8">
                                                            {element.description}
                                                    </div>
                                                 </div>
                                        ))}
                                    {attachmentData && attachmentData.length === 0 && (
                                        <p>Not uploaded</p>
                                    )}
                                </div>
                            </div>
                        </div>)}
                </div>
                </React.Fragment> 
                )}
                <hr />
                {relatedPartyDetails
                    && relatedPartyDetails.isPatientFile && (
                        <div className="row">
                            <div className="col-md-12">
                                <h6 className={style.viewHeading}>Patient File</h6>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <span
                                            class={style.caseFileWrapper}
                                            onClick={() => this.onDownloadSubmitFile(relatedPartyDetails)}
                                        >
                                            <i
                                                class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                            ></i>
                                            {relatedPartyDetails &&
                                                !relatedPartyDetails.file_number && (
                                                    <span> {`${relatedPartyDetails &&
                                                        relatedPartyDetails.name} ${relatedPartyDetails &&
                                                        relatedPartyDetails.surname}.pdf`} </span>)}

                                            {relatedPartyDetails &&
                                                relatedPartyDetails.file_number && (
                                                    <span> {`${relatedPartyDetails &&
                                                        relatedPartyDetails.file_number}.pdf`} </span>)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                <div className="row">
                    <div className="col-md-12">
                        {(this.state.isLoading || this.state.isCaseFileDownloading) ? (
                            <div className={style.loadingWrapper}>
                                <img src={ttmLoader} alt="loader" className={style.loading} />
                            </div>
                        ) : (
                                <div>
                                    {this.state.successMessage && (
                                        <p className="success-message">
                                            {this.state.successMessage}
                                        </p>
                                    )}
                                    {this.state.errorMessage && (
                                        <p className="error-message">
                                            {this.state.errorMessage}
                                        </p>
                                    )}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );
    }


    render() {
        const filteredInventoryData = Tabs.find(
            (element, index) => {
                return element.tabId == this.state.activeTab;
            });

        if (!this.state.isScreenLoaded) {
            return (
                <div className="dashboard-loader">
                    <img src={ttmLoader} alt="loader" className="loader-image" />
                </div>
            );
        }
        return (
            <div>
                {this.props.loading ? (
                    <div className={style.loadingWrapper}>
                        <img src={ttmLoader} alt="loader" className={style.loading} />
                    </div>
                ) : (
                        <div className={`inventory-audit ${style.patientDetailsWrapper}`}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h3>Patient Details</h3>
                                </div>
                                <div className="col-lg-12 intro-text">
                                    <p className="mb-4">
                                        This is the patient details section. There are two tabs general details and MSV details.
                                        General details will have patient information and MSV details will have details of last two MSV responses.
                </p>
                                </div>
                            </div>
                            <div className={`row ${style.patientDetailsTabWrapper}`}>
                                <div className="col-md-12">
                                    <Nav tabs>
                                        {Tabs && Tabs.map(
                                            (element, index) => {
                                                if (element.enable === 1) {
                                                    return (<NavItem key={`${index + 1}`}>
                                                        <NavLink
                                                            className={{
                                                                active: this.state.activeTab === `${index + 1}`,
                                                            }}
                                                            onClick={() => {
                                                                this.toggle(`${index + 1}`);
                                                            }}
                                                        >
                                                            {element.tabName}
                                                        </NavLink>
                                                    </NavItem>)
                                                }
                                            }
                                        )}
                                    </Nav>
                                    <TabContent
                                        activeTab={this.state.activeTab}
                                        className={style.tabContentWrapper}
                                    >
                                        {Tabs[0].enable === 1 &&
                                            (<TabPane
                                                tabId={`1`}
                                                key={`1`}
                                                className={style.auditTrailTabContent}
                                            >
                                                {this.state.activeTab == 1 && (
                                                    <div>
                                                        {this.getGeneralDetails()}
                                                    </div>
                                                )}
                                            </TabPane>)}
                                        {Tabs[1].enable === 1 &&
                                            (<TabPane
                                                tabId={`2`}
                                                key={`2`}
                                                className={style.auditTrailTabContent}
                                            >
                                                {this.state.activeTab == 2 && (                                                  
                                                    <div>
                                                    {this.getMSVDetails()}
                                                    </div>
                                                )}
                                            </TabPane>)}
                                    </TabContent>
                                </div>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        relatedPartyData: state.relatedPartyData,
        dropdownListData: state.dropdownList,
        schemesData: state.schemes,
        schemesPlanData: state.schemesPlan,
        schemesPlanOptionsData: state.schemesPlanOptions,
        schemesPlanSubOptionsData: state.schemesPlanSubOptions,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchRelatedParty: (value) => dispatch(fetchRelatedParty(value)),fetchMedSchemes: (scheme) => dispatch(fetchMedSchemes(scheme)),
        fetchMedSchemesPlan: (scheme_code) => dispatch(fetchMedSchemesPlan(scheme_code)),
        fetchMedSchemesPlanOptions: (plan_code) => dispatch(fetchMedSchemesPlanOptions(plan_code)),
        fetchMedSchemesPlanSubOptions: (plan_option_code) => dispatch(fetchMedSchemesPlanSubOptions(plan_option_code)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPatient);
